import React, { useContext, useEffect, useRef, useState } from 'react';
import useCollapse from 'react-collapsed';
import { config } from '@fortawesome/fontawesome-svg-core'
import {faLocationDot, faSwimmingPool, faArrowDownToSquare, faArrowUpFromSquare} from '@fortawesome/pro-regular-svg-icons'
import { faBed as fasBed, faHotTub as fasHotTub, faShower as fasShower, faUsers as fasUsers,  faHotel as fasHotel, faStar as fasStar } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Checkers from '../../../../../../helpers/class/Checkers';
import { localizeUnits } from '../../../../../../helpers/PropertyUnits';
import { useT } from '../../../../../../helpers/i18n';
import Methods from '../../../../../../helpers/class/Methods';

import '@fortawesome/fontawesome-svg-core/styles.css'

config.autoAddCss = false;

import { useInViewport } from 'react-in-viewport';
import { useSelector } from 'react-redux';

import * as appContext from '../../../../../AppContext';
import ReadMoreText from '../../../../../ReadMoreText';

export default function PropertyHeading ( props ) {
  const [isPublicDomain, setIsPublicDomain] = useState(useSelector(state => state['appSettings']['isPublicDomain']))
  const classification = useSelector(state => state['singlePropertyData']['classification'])
  const typeTitle = useSelector(state => state['singlePropertyData']['typeTitle'])
  const [publicDomain, setPublicDomain] = useState(0);
  const isHotel = props.details.system_type_id === 2 ? true : false
  const isChain = props.hasOwnProperty('isChain') ? props.isChain : false

  useEffect(() => {
    setPublicDomain(isPublicDomain)
  }, [isPublicDomain, setPublicDomain, classification])
  const config = {disconnectOnLeave: false};
  const options = {};
  const myRef = useRef();
  const {
    inViewport
  } = useInViewport(
      myRef,
      options,
      config,
      props
  );

  const tUnits = useT();

  const arrayHandler = () => {
    let array = [
      {key: 'guests', value: props.details.capacity},
      {key: 'bedrooms', value: props.details.bedrooms},
      {key: 'bathrooms', value: props.details.bathrooms},
      {key: 'pools', value: props.details.pools},
      {key: 'jacuzzi', value: props.details.jacuzzi},
    ];

    if (Checkers.isValidPositiveNumber(props.details.property_area_sqm)) {
      array.push({key: 'indoor_area', value: props.details.property_area_sqm + " m<sup>2</sup> indoor"},)
    }

    if (Checkers.isValidPositiveNumber(props.details.property_area_outdoor_sqm)) {
      array.push({key: 'outdoor_area', value: props.details.property_area_outdoor_sqm + ' m<sup>2</sup> outdoor'},)
    }

    return array
  }

  const hotelArray = [
    {key: 'typeTitle', value: typeTitle},
    {key: 'classification', value: classification},
  ];

  const [isExpanded, setExpanded] = React.useState(false);
  const {getCollapseProps} = useCollapse({
    isExpanded
  });

  const [propertyTitle, setPropertyTitle] = useState(props.details.property_title)

  const alternative_title = props.details.alternative_title

  useEffect(() => {
    if (alternative_title != undefined && publicDomain == 1) {
      if (alternative_title.length > 0) {
        setPropertyTitle(alternative_title)
      }
    }
  }, [publicDomain, setPropertyTitle, alternative_title])

  let viewPortResult = null;
  // if(!inViewport){
  //     viewPortResult =
  //         <>
  //             <Skeleton height={30} className="col-8 col-sm-6 col-md-4 b-rad-md mb-1" />
  //             <Skeleton height={42} className="col-8 col-sm-6 col-md-4 b-rad-md mb-2"/>
  //             <Skeleton height={30} className="col-12 col-sm-8 col-md-6 b-rad-md mb-1"/>
  //             <Skeleton height={150} className="col-12 b-rad-lg"/>
  //         </>
  //     ;
  // } else {
  viewPortResult =
      <>
        {(Checkers.isValidString(props.location.address) || Checkers.isValidString(props.location.address)) &&
            <p className="block-title hint-text no-margin">
              <FontAwesomeIcon icon={faLocationDot} className={'m-r-10'}/>
              {Checkers.isValidString(props.location.address) && props.location.address}
              {Checkers.isValidString(props.location.address) && ',\ ' + props.location.city}
            </p>
        }
        {
          <h2 className="bold m-t-5 m-b-30">{propertyTitle}</h2>
        }
        {isHotel === true ?
            <p>
              {
                hotelArray.map((item, index, elements) => {
                  if (Checkers.isValidString(item.value)) {
                    return (
                        <span aria-hidden="true" key={item.key.toString()}>
                  <FontAwesomeIcon
                      icon={
                        item.key == 'classification' ? fasStar
                            : item.key == 'typeTitle' ? fasHotel
                                : null
                      }
                      className="text-master"/> {localizeUnits(item.value, tUnits)}
                          {
                              elements[index + 1] != null && Checkers.isValidString(elements[index + 1].value) &&
                              <span aria-hidden="true" key={'dot-' + index}> · </span>
                          }
                </span>
                    )
                  }
                })

                // Checkers.isValidString(classification) ?
                //   <>
                //     <span aria-hidden="true">
                //       &nbsp;<FontAwesomeIcon  icon={fasStar} className="text-master"/> {classification} · &nbsp;<FontAwesomeIcon icon={fasHotel} className="text-master"/> {typeTitle}
                //     </span>
                //   </>
                //   :
                //   <>
                //   </>

              }
            </p>

            : <p>
              {
                  !isChain && arrayHandler().map((item, index, elements) => {
                    if (Checkers.isValidString(item.value)) {
                      return (
                          <span aria-hidden="true" key={item.key.toString()}>
                  <FontAwesomeIcon
                      icon={
                        item.key == 'guests' ? fasUsers
                            : item.key == 'bedrooms' ? fasBed
                                : item.key == 'bathrooms' ? fasShower
                                    : item.key == 'jacuzzi' ? fasHotTub
                                        : item.key == 'indoor_area' ? faArrowDownToSquare
                                            : item.key == 'outdoor_area' ? faArrowUpFromSquare
                                                : faSwimmingPool
                      }
                      className="text-master"/> <span dangerouslySetInnerHTML={{__html: localizeUnits(item.value, tUnits)}}/>
                            {
                              index < elements.length - 1 ?
                                  <span aria-hidden="true" key={'dot-' + index}> · </span>
                                  :
                                  <></>
                            }
                </span>
                      )
                    }
                  })
              }
            </p>
        }
      </>
  ;
  // }

  return (
      <div ref={myRef} id="pro_detail_desc" className="row full-width no-margin">
        {viewPortResult}
      </div>
  )
}
